import { render } from "./EventsPage.vue?vue&type=template&id=63dc279c"
import script from "./EventsPage.vue?vue&type=script&lang=js"
export * from "./EventsPage.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__